export default class StatusProgressState {
  label;
  key;

  constructor(key, label = null) {
    this.key = key;
    this.label = label;
  }

  getLabel() {
    return this.label || this.key.replace(/-/g, ' ');
  }

  getKey() {
    return this.key;
  }
}